import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { DataTable } from "../../../../common/DataTable";
import { FormattedMessage, FormattedDate } from "react-intl";
import { DownloadS3Button } from "../../../../common";
import { ACCOUNTING_EXPORTS } from "../../../../../utils/data/models";
import { bindActionCreators } from "redux";
import * as dataActions from "../../../../../utils/data/dataActions";
import { getS3Informations } from "../../../../common/environmentProperties";

const S3_BUCKET = getS3Informations();

const LIMIT_EXPORTS_DISPLAYED = 6;

class AccountingExportsDataTable extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.getData = this.getData.bind(this);
    this.sortDates = this.sortDates.bind(this);
    this.regroupReports = this.regroupReports.bind(this);

    this.state = {
      sortedData: null,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.items.length > 0 && prevProps.items != this.props.items) {
      this.regroupReports();
    } else if (
      this.props.items.length == 0 &&
      this.state.sortedData &&
      this.state.sortedData.length > 0
    ) {
      this.setState({ sortedData: [] });
    }
  }

  getData() {
    return this.state.sortedData;
  }

  regroupReports() {
    /**
     * This function will regroup the reports.
     * Since we have 3 reports per row in the data table,
     * we need to regroup the reports that are in the same period.
     */

    let groupedArray = [];

    // First we get all the fetched periods and push them to an array.

    for (let i = 0; i < this.props.items.length; i++) {
      let formattedItemPeriod = this.props.items[i].period.replace("-", "/");
      let existantElementIndex = groupedArray.findIndex(
        (element) => element.period == formattedItemPeriod
      );
      let format = this.props.items[
        i
      ].relationships.export_configurations.object.format.toLowerCase();

      const isDelayed = this.props.items[i].object_name.includes("delayed");

      if(isDelayed) {
        format = format + "_" + "delayed"; 
      }

      if (groupedArray.length == 0 || existantElementIndex == -1) {
        /**
         * If the current loop's element period is not in the array,
         * we add it, and we also add the report format.
         */
        groupedArray.push({
          period: formattedItemPeriod,
          [format]: this.props.items[i],
        });
      } else {
        /**
         * If period already exists in array, we append the current element's format to the
         * array.
         */
        groupedArray[existantElementIndex][format] = this.props.items[i];
      }
    }

    let sortedArray = this.sortDates(groupedArray);

    this.setState({ sortedData: sortedArray });
  }

  sortDates(items) {
    /**
     * This function will allow us to sort the periods inside our items (YYYY/MM format).
     */

    items.sort((a, b) => {
      let dateA = new Date(a.period);

      let dateB = new Date(b.period);
      // Changing to accepted format for FormattedDate
      a.period = a.period.replace("-", "/");
      b.period = b.period.replace("-", "/");
      return dateB - dateA;
    });
    return items;
  }

  getCols() {
    let cols = [
      {

        name: (
          <span className="export-text-size">
            <FormattedMessage id="accountingExport.billingPeriod" />
          </span>
        ), // For some reason the datatable doesn't recognize our scss classes, so I had to use inline styles.
        display: (exports) => (
          <div className="text-capitalize">
            <FormattedDate 
              value={exports.period.replace("/", "-")} 
              year="numeric" 
              month="long"
              timeZone="UTC"
            />
          </div>
        ),
        widthPct: 45,
      },
      {
        name: (
          <span className="dt-headers">
            <FormattedMessage id="accountingExport.version" />
          </span>
        ),
        display: (exports) => (
          <div className="flex">
            <div className="version-elements">
              <span className="version-text">
                <FormattedMessage
                  className="version-text"
                  id="accountingExport.acomba"
                />
              </span>
              <DownloadS3Button
                model={ACCOUNTING_EXPORTS}
                blockButton={exports.acomba ? false : true}
                identifier={exports.acomba ? exports.acomba.object_name : null} // object_name = file name
                attachment={
                  exports.acomba
                    ? {
                        objectPath: exports.acomba.object_path,
                        objectName: exports.acomba.object_name,
                        bucketName: S3_BUCKET.exports.bucket_name,
                        regionName: S3_BUCKET.exports.region_name,
                      }
                    : null
                }
                label={""}
              />
            </div>
            <div className="version-elements">
              <span className="version-text">
                <FormattedMessage
                  className="version-text"
                  id="accountingExport.acombaDelayed"
                />
              </span>
              <DownloadS3Button
                model={ACCOUNTING_EXPORTS}
                blockButton={exports["acomba_delayed"] ? false : true}
                identifier={exports["acomba_delayed"]  ? exports["acomba_delayed"].object_name : null} // object_name = file name
                attachment={
                  exports["acomba_delayed"]
                    ? {
                        objectPath: exports["acomba_delayed"].object_path,
                        objectName: exports["acomba_delayed"].object_name,
                        bucketName: S3_BUCKET.exports.bucket_name,
                        regionName: S3_BUCKET.exports.region_name,
                      }
                    : null
                }
                label={""}
              />
            </div>
          </div>
        ),
        widthPct: 35,
      },
    ];

    return cols;
  }

  render() {
    const { sortedData } = this.state;

    return (
      <div>
        <DataTable
          ref="dataTable"
          getData={this.getData}
          cols={this.getCols()}
          data={sortedData ? sortedData : []}
          offset={0}
          rowsPerPage={LIMIT_EXPORTS_DISPLAYED}
          rowHeight={60}
          showFilters={false}
          showOverflow={false}
          totalRows={LIMIT_EXPORTS_DISPLAYED}
        />
      </div>
    );
  }
}

AccountingExportsDataTable.propTypes = {
  items: PropTypes.array,
};

function mapDispatchToProps(dispatch) {
  return {
    dataActions: bindActionCreators(dataActions, dispatch),
  };
}

function mapStateToProps(state) {
  const data = state.data.accountingExports || {};
  return {
    items: data.items || [],
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountingExportsDataTable);



// WEBPACK FOOTER //
// ./src/components/dashboard/importExport/exports/accounting/AccountingExportsDataTable.js